import pt from '@/assets/images/pt.svg';
import { isBSCNetwork } from '@/constant';
import user from '@/stores/user';
import { TYPE } from '@/theme';
import { observer } from 'mobx-react';
import React from 'react';
import { useHistory } from 'react-router-dom';

const PointsWrapper: React.FC = observer(() => {
    const history = useHistory();
    const { userDetail, bscTotalScore } = user;

    return (
        <>
            {isBSCNetwork ? (
                <div
                    className="pt-wrapper"
                    onClick={() => history.push('/points')}
                >
                    <img src={pt} alt="point icon" />
                    <TYPE.main>{`Total: ${bscTotalScore} pts`}</TYPE.main>
                </div>
            ) : (
                <div
                    className="pt-wrapper"
                    onClick={() =>
                        window.open('https://lazpad.fun/dashboard', '_blank')
                    }
                >
                    <img src={pt} alt="point icon" />
                    <TYPE.main>
                        {`Total: ${
                            userDetail?.scoreInfo?.commonScore ?? 0
                        } pts`}
                    </TYPE.main>
                </div>
            )}
        </>
    );
});

export default PointsWrapper;
